import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { map } from 'lodash'

import styles from './TabOrderItems.module.scss'
import { ReactComponent as Checkmark } from '../../assets/icons/tabs/checkmark-circle.svg'
import { ReactComponent as LockedCheckmark } from '../../assets/icons/tabs/checkmark-circle-locked.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/close.svg'

const eventHandler = (callback, event) => {
  event.stopPropagation()
  callback(event)
}

const TabOrderItems = ({ items, selectable, onSelectItem, selectedItemIndexes, lockedItemIndexes, className, onRemove, ...props }) => {
  const classNames = cn(styles.tabOrderItems, className)
  const renderItem = (item, index) => (
    <div className={styles.item} key={`${item.id}-${index}`} onClick={() => onSelectItem(index)}>
      <div className={styles.column}>
        <span className={styles.quantity}>{item.quantity}</span>
      </div>
      <div className={styles.column}>
        <span className={styles.name}>{item.name}</span>
        <span className={styles.modifiers}>{item.modifiersString}</span>
      </div>
      <div className={styles.column}>
        <span className={styles.price}>{item.price}</span>
      </div>
      {onRemove && <div className={styles.column}>
          <CloseIcon className={styles.remove} onClick={eventHandler.bind(this, () => onRemove(index))}></CloseIcon>
        </div>}
    </div>
  )

  const renderSelectableItem = (item, index) => {
    const isSelected = selectedItemIndexes.includes(index)
    const isLocked = lockedItemIndexes.includes(index)
    const onClick = isLocked ? () => {} : () => onSelectItem(index)
    let checkmarkElement = <span className={cn(styles.checkmark, { [styles.selected]: isSelected })}>{isSelected ? <Checkmark /> : null}</span>

    if (isLocked) {
      checkmarkElement = <span className={cn(styles.checkmark, styles.locked)}><LockedCheckmark /></span>
    }

    return (
      <div className={styles.selectableItem} key={`${item.id}-${index}`} onClick={onClick}>
        <div className={styles.column}>
          <span className={styles.quantity}>{item.quantity}</span>
        </div>
        <div className={styles.column}>
          <span className={styles.namePrice}>{item.name} - {item.price}</span>
          <span className={styles.modifiers}>{item.modifiersString}</span>
        </div>
        <div className={styles.column}>
          {checkmarkElement}
        </div>
      </div>
    )
  }

  return (
    <div {...props} className={classNames}>
      {map(items, selectable ? renderSelectableItem : renderItem)}
    </div>
  )
}

TabOrderItems.defaultProps = {
  items: [],
  selectable: false,
  onSelectItem: () => {},
  selectedItemIndexes: [],
  lockedItemIndexes: [],
}

TabOrderItems.propTypes = {
  items: PropTypes.array,
  selectable: PropTypes.bool,
  onSelectItem: PropTypes.func,
  selectedItemIndexes: PropTypes.array,
  lockedItemIndexes: PropTypes.array,
}

export default TabOrderItems
